import classNames from 'classnames';
import { FC, MouseEvent } from 'react';
import { NEW_TAB_ATTRIBUTES } from '../../constants';
import getClassNames from '../../utils/getClassNames';
import Icon, { IconProps } from '../Icon';

import styles from './ShareCard.module.scss';

export type ShareCardProps = {
  icon: IconProps['id'];
  title: string;
  subTitle?: string;
  contentTitle: string;
  url?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

const ShareCard: FC<ShareCardProps> = ({
  icon,
  title,
  subTitle = '',
  contentTitle,
  url = '',
  onClick,
}) => {
  const hasSubtitle = !!subTitle;
  return (
    <a
      className={getClassNames(styles, 'root', classNames({ hasSubtitle }))}
      title={contentTitle}
      {...(!onClick ? NEW_TAB_ATTRIBUTES : {})}
      href={url}
      onClick={onClick}
      rel="noreferrer"
      target="_blank"
    >
      <Icon
        id={icon}
        className={styles.icon}
      />
      <h4 className={styles.title}>{title}</h4>
      {hasSubtitle && <h5 className={styles.subTitle}>{subTitle}</h5>}
    </a>
  );
};

export default ShareCard;
